import React, { useContext,useEffect, useState } from "react";
import { Button, Col, Row, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import schoolApi from "../../api/schoolApi";
import { ShimmerTable } from "react-shimmer-effects";
import moment from "moment";
import { generateAndDownloadIDCards } from "../../utils/idCardHelper";
import InfoPill from "../InfoPill";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import { Link } from "react-router-dom";

import { Helmet } from "react-helmet";
import { usePermissions } from "../contexts/PermissionContext";
import { MdFilterAlt } from "react-icons/md";
import FilterComponent from "../subject/filter_component";
import { toast, ToastContainer } from "react-toastify";
import { SessionContext } from "../SessionProvider";
const StaffList = (props) => {
  const { selectedSessionId, currentSessionId } = useContext(SessionContext);
  const [isCurrentSession,setIsCurrentSession] = useState();

  const { rolePermissions, userInfo } = usePermissions();
  const navigate = useNavigate();
  const [body, setBody] = useState();
  const [settingsList, setSettingsList] = useState([]);
  const [orientation, setOrientation] = useState("vertical");
  const [isDownloading, setIsDownloading] = useState(false);
  const [selectedStaffIds, setSelectedStaffIds] = useState([]);
  const [tempColor, setTempColor] = useState("#d1b2b2");
  const [textColor, setTextColor] = useState("#faf4f4");
  //const [body, setContacts] = useState();
  console.log("🚀 ~ StaffList ~ body:", body);

  const [colSize, setColSize] = useState({ tableSize: 12, filterSize: 0 });
  const [isFilter, setIsFilter] = useState(false);
  const [addSearchRecShow, setAddSearchRecShow] = useState(false);

  console.log("🚀 ~ StaffList ~ selectedSessionId:", selectedSessionId);

  useEffect(() => {
    async function init() {
      try {
        if (currentSessionId !== null && currentSessionId !== undefined) {
          setIsCurrentSession(selectedSessionId === currentSessionId);
        }
      } catch (error) {
        console.log('error=>', error);
      }
    }
    init();
  }, [selectedSessionId,isCurrentSession]);

  // useEffect(() => {
  //   async function init() {
  //     try {
  //       const result = await schoolApi.fetchStaffContacts();
  //       if (result.success) {
  //         setBody(result.contacts);
  //         setContacts(result.contacts);
  //       } else {
  //         setBody([]);
  //         setContacts([]);
  //       }
  //     } catch (error) {
  //       setBody([]);
  //       setContacts([]);
  //     }
  //   }
  //   init();
  // }, []);

  useEffect(() => {
    const init = async () => {
      if (!selectedSessionId) return;

      try {
        const result = await schoolApi.fetchStaffContacts();
        if (result.success) {
          const filteredContacts = result.contacts.filter(
            (contact) => contact.session_id === selectedSessionId
          );
          setBody(filteredContacts);
          setSelectedStaffIds([]);
        //  setContacts(filteredContacts);
        } else {
          setBody([]);
        }
      } catch (error) {
        console.error("Error fetching contacts:", error);
        setBody([]);
      }
    };

    init();
  }, [selectedSessionId]);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const settingsResult = await schoolApi.getAllSetting();
      if (settingsResult?.success && settingsResult?.data) {
        setSettingsList(settingsResult.data);
        const colorSetting = settingsResult.data.find((s) => s.key === "id_card_color");
        const textColorSetting = settingsResult.data.find((s) => s.key === "id_card_text_color");
        const activeOrientSetting = settingsResult.data.find((s) => s.key === "id_card_active_orientation");
        if (colorSetting) setTempColor(colorSetting.value || "#d1b2b2");
        if (textColorSetting) setTextColor(textColorSetting.value || "#faf4f4");
        if (activeOrientSetting && activeOrientSetting.value) setOrientation(activeOrientSetting.value);
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
    }
  };

  const getActiveOrientation = () => {
    return settingsList.find((s) => s.key === "id_card_active_orientation")?.value || orientation || "vertical";
  };

  const getDynamicSchemaForOrientation = (targetOrientation) => {
    const settingKey = targetOrientation === "vertical" ? "id_card_template_vertical" : "id_card_template_horizontal";
    const foundTplSetting = settingsList.find((s) => s.key === settingKey);
    if (foundTplSetting && foundTplSetting.value) {
      try {
        const parsed =
          typeof foundTplSetting.value === "string" && foundTplSetting.value.trim().startsWith("{")
            ? JSON.parse(foundTplSetting.value)
            : foundTplSetting.value;
        if (parsed && Array.isArray(parsed.elements) && parsed.elements.length > 0) {
          return parsed;
        }
      } catch (e) {
        console.warn("Could not parse dynamic card template:", e);
      }
    }
    return null;
  };

  const downloadIDCards = async (mode) => {
    const currentOrientation = typeof mode === "string" && (mode === "vertical" || mode === "horizontal") ? mode : getActiveOrientation();
    const staffToDownload = selectedStaffIds.length
      ? body?.filter((staff) => selectedStaffIds.includes(staff.id))
      : body;

    if (!staffToDownload || staffToDownload.length === 0) {
      toast.warning("No employees available to download!");
      return;
    }

    setIsDownloading(true);
    try {
      const dynamicSchema = getDynamicSchemaForOrientation(currentOrientation);
      const staffStudents = staffToDownload.map((staff) => ({
        ...staff,
        entityType: "staff",
        studentname: staff.staffname || `${staff.firstname || ""} ${staff.lastname || ""}`.trim(),
        registration_no: staff.employee_id || staff.emp_id || (staff.id ? `EMP-${staff.id.split("-")[0].toUpperCase()}` : "N/A"),
        phone: staff.phone || staff.mobile || "",
        street: staff.street || staff.address || "",
        designation: staff.recordtype || staff.designation || "Staff",
        qualification: staff.qualification || staff.department || "",
      }));
      await generateAndDownloadIDCards({
        students: staffStudents,
        orientation: currentOrientation,
        dynamicSchema,
        tempColor,
        textColor,
        userInfo,
      });
    } catch (error) {
      console.error("Error:", error);
      toast.error("Failed to generate ID cards");
    } finally {
      setIsDownloading(false);
    }
  };

  const canCreate = rolePermissions?.Employee_List?.can_create;
  const canEdit = rolePermissions?.Employee_List?.can_edit;

  const handleSelectStaff = (staffId) => {
    setSelectedStaffIds((currentIds) =>
      currentIds.includes(staffId)
        ? currentIds.filter((id) => id !== staffId)
        : [...currentIds, staffId]
    );
  };

  const handleSelectAllStaff = () => {
    if (selectedStaffIds.length === body?.length && body?.length > 0) {
      setSelectedStaffIds([]);
      return;
    }

    setSelectedStaffIds(body?.map((staff) => staff.id).filter(Boolean) || []);
  };

  const header = [
    {
      title: (
        <input
          type="checkbox"
          checked={body?.length > 0 && selectedStaffIds.length === body.length}
          onChange={handleSelectAllStaff}
          style={{ cursor: "pointer", width: "18px", height: "18px" }}
        />
      ),
      displayName: "Select",
      prop: "selection",
      show: true,
      cell: (row) => (
        <input
          type="checkbox"
          checked={selectedStaffIds.includes(row.id)}
          onChange={() => handleSelectStaff(row.id)}
          style={{ cursor: "pointer", width: "18px", height: "18px" }}
        />
      ),
    },
    {
      title: "Employee Name",
      show: true,
      prop: "staffname",
      isFilterable: true,
      show: true,
      cell: (row) => (
        <Link to={"/staff/" + row.id} state={row}>
          {row.staffname}
        </Link>
      ),
    },
    { title: "Street", prop: "street", show: true, isFilterable: true },
    { title: "City", prop: "city", show: true, isFilterable: true },
    {
      title: "Date of Birth",
      prop: "dateofbirth",
      isFilterable: true,
      show:
        userInfo?.userrole === "SYS_ADMIN" || userInfo?.userrole === "ADMIN"
          ? true
          : canCreate,
      cell: (row) => moment(row.dateofbirth).format("DD-MM-YYYY"),
    },
    { title: "Phone", prop: "phone", show: true, isFilterable: true },
    { title: "Email", prop: "email", show: true, isFilterable: true },
    {
      title: "Employee Type",
      prop: "recordtype",
      show: true,
      isFilterable: true,
    },
  ];

  const visibleHeader = header?.filter((col) => col.show);

  const labels = {
    beforeSelect: " ",
  };

  const createContact = () => {
    if (
      canEdit ||
      userInfo?.userrole === "SYS_ADMIN" ||
      userInfo?.userrole === "ADMIN"
    ) {
      navigate(`/staff/e`);
    }
  };

  const addFilter = () => {
    setAddSearchRecShow(!addSearchRecShow);
    setIsFilter(!isFilter);
    if (!addSearchRecShow) {
      setColSize({ tableSize: 9, filterSize: 3 });
    } else {
      setColSize({ tableSize: 12, filterSize: 0 });
    }
  };

  return (
    <>
      <Helmet>
        {" "}
        <title>{props?.tabName}</title>{" "}  
      </Helmet>
      <Col lg={2} className="mx-3 ">
        <Link className="nav-link mx-2" to="/">
          Home <i className="fa-solid fa-chevron-right"></i> Employee List
        </Link>
      </Col>
      <Row className="g-0">
        <Col lg={12} className="p-lg-4 mb-4">
          {body ? (
            <DatatableWrapper
              body={body}
              headers={visibleHeader}
              paginationOptionsProps={{
                initialState: {
                  rowsPerPage: 15,
                  options: [5, 10, 15, 20],
                },
              }}
            >
              <Row className="mb-4">
                <Col lg={3}>
                  <Filter />
                </Col>
                <Col lg={1} style={{ "margin-top": "-18px" }}>
                  <PaginationOptions labels={labels} />
                </Col>
                <Col lg={6} style={{ "margin-top": "-13px" }}>
                  <div>
                    <InfoPill left="Total Employees" right={body?.length} />
                  </div>
                </Col>
                <Col
                  lg={2}
                  className="d-flex flex-col justify-content-end align-items-end gap-2"
                >
                  {(userInfo?.userrole === "SYS_ADMIN" ||
                    userInfo?.userrole === "ADMIN" ||
                    canCreate) && (
                    <Button
                      className="btn-light add-new-button btn"
                      variant=""
                      onClick={() => createContact(true)}
                      disabled={isCurrentSession === false?true:false}
                    >
                      Add
                    </Button>
                  )}
                  <div className="dropdown">
                    <Button
                      className="btn btn-primary dropdown-toggle"
                      disabled={isDownloading}
                      style={{ padding: "6px 12px", fontSize: "13px", whiteSpace: "nowrap" }}
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {isDownloading ? "Generating..." : <><i className="fa-solid fa-download"></i> Download</>}
                    </Button>
                    <ul className="dropdown-menu">
                      <li className="position-relative group-submenu">
                        <button type="button" className="dropdown-item d-flex justify-content-between align-items-center">
                          <span className="d-flex align-items-center gap-2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                              <path d="M2 2h12v3H2V2zm0 4h12v3H2V6zm0 4h12v3H2v-3z" />
                            </svg> Download Id Card
                          </span>
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M10.854 8.354a.5.5 0 0 0 0-.708L7.672 4.464a.5.5 0 1 0-.708.708L9.793 8l-2.829 2.828a.5.5 0 1 0 .708.708l3.182-3.182z" />
                          </svg>
                        </button>
                        <ul className="dropdown-menu submenu">
                          <li>
                            <button
                              type="button"
                              className="dropdown-item d-flex align-items-center gap-2 text-success fw-bold"
                              onClick={() => downloadIDCards()}
                            >
                              <i className="fa-solid fa-wand-magic-sparkles me-2"></i> Active Saved Design ({(getActiveOrientation() || "vertical").toUpperCase()})
                            </button>
                          </li>
                          <li>
                            <hr className="dropdown-divider my-1" />
                          </li>
                          <li>
                            <button type="button" className="dropdown-item d-flex align-items-center gap-2" onClick={() => downloadIDCards("vertical")}>
                              <i className="fa-solid fa-arrow-up me-2"></i> Vertical
                            </button>
                          </li>
                          <li>
                            <button type="button" className="dropdown-item d-flex align-items-center gap-2" onClick={() => downloadIDCards("horizontal")}>
                              <i className="fa-solid fa-arrow-right me-2"></i> Horizontal
                            </button>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                  <Button
                    className="btn"
                    variant="outline-secondary"
                    onClick={addFilter}
                    style={{ marginLeft: "10px" }}
                  >
                    <span className="d-inline-flex align-items-center">
                      <MdFilterAlt
                        style={{
                          marginRight: "0px",
                          paddingTop: "2px",
                          fontSize: "15px",
                        }}
                      />
                    </span>
                  </Button>
                </Col>
              </Row>
              {}
              <Row>
                <Col lg={`${colSize.tableSize}`}>
                  <Table striped className="data-table">
                    <TableHeader />
                    <TableBody />
                  </Table>
                  <Pagination />
                </Col>
                <Col lg={colSize.filterSize}>
                  {addSearchRecShow && (
                    <FilterComponent
                      show={addSearchRecShow}
                      onHide={() => setAddSearchRecShow(false)}
                      setBody={setBody}
                    />
                  )}
                </Col>
              </Row>
            </DatatableWrapper>
          ) : (
            <ShimmerTable row={10} col={8} />
          )}
        </Col>
        <Col lg={2}></Col>
        <ToastContainer
          position="top-right"
          autoClose={2000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </Row>
    </>
  );
};

export default StaffList;
